var unitDescription = {
    B:{
        description: 'Byte',
        power10: 3,
        power2:0
    },
    KB:{
        description: 'KiloByte',
        power10: 6,
        power2:10
    },
    MB:{
        description: 'MegaByte',
        power10: 9,
        power2: 20
    },
    GB:{
        description: 'GigaByte',
        power10: 12,
        power2: 30
    },
    TB:{
        description: 'TeraByte',
        power10: 15,
        power2: 40
    },
    PB:{
        description: 'PetaByte',
        power10: 18,
        power2: 50
    },
    EB:{
        description: 'ExaByte',
        power10: 21,
        power2: 60
    },
    ZB:{
        description: 'ZettaByte',
        power10: 24,
        power2: 70
    },
    YB:{
        description: 'YottaByte',
        power10: 24,
        power2: 80
    }
};

module.exports = unitDescription;



//////////////////
// WEBPACK FOOTER
// ./node_modules/byte-converter/lib/unit-description.js
// module id = tluY
// module chunks = 0